import { saveAs } from 'file-saver';

import api from '../api';

export type TDownloadAppleWallet = {
  policyId: string;
  isRenewalIdCard: boolean;
};

function base64ToBuffer(str: string) {
  const decodedStr = window.atob(str);
  const buffer = new ArrayBuffer(decodedStr.length);
  const view = new Uint8Array(buffer);
  for (let i = 0; i < decodedStr.length; i++) {
    view[i] = decodedStr.charCodeAt(i);
  }
  return buffer;
}

function downloadAppleWallet({
  policyId,
  isRenewalIdCard = false,
}: TDownloadAppleWallet) {
  return new Promise((resolve, reject) => {
    api
      .downloadDigitalId(policyId, {
        id_type: 'apple',
        is_preview: isRenewalIdCard,
      })
      .then((response) => {
        if (response.file) {
          const blob = new Blob([base64ToBuffer(response.file)], {
            type: 'application/vnd.apple.pkpass',
          });
          const filename = 'toggle-auto.pkpass';
          saveAs(blob, filename);
          resolve(response);
        } else {
          reject(response);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function downloadAndroidWallet({
  policyId,
  isRenewalIdCard = false,
}: TDownloadAppleWallet) {
  return new Promise((resolve, reject) => {
    api
      .downloadDigitalId(policyId, {
        id_type: 'android',
        is_preview: isRenewalIdCard,
      })
      .then((response) => {
        if (response.link) {
          const win = window.open(response.link, '_blank');
          win?.focus();
          resolve(response);
        } else {
          reject(response);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export default {
  downloadAppleWallet,
  downloadAndroidWallet,
};
